import React from 'react';
import Icon from '../../../components/AppIcon';

const TechnicalTimeline = ({ timelineData }) => {
  // Handle cases where timelineData is empty or not provided
  if (!timelineData || timelineData.length === 0) {
    return (
      <div className="bg-card rounded-xl p-6 shadow-elegant text-center">
        <p className="text-muted-foreground">No technical timeline data available.</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl p-6 shadow-elegant">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="GitBranch" size={24} className="text-primary" />
        <h3 className="text-2xl font-bold text-foreground">Technical Evolution</h3>
      </div>
      <div className="relative">
        {/* Main vertical line of the timeline */}
        <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-accent to-primary"></div>

        <div className="space-y-8">
          {timelineData.map((item, index) => (
            <div key={index} className="relative flex items-start space-x-6">
              {/* Timeline Dot with Icon */}
              <div className="relative z-10 flex-shrink-0">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center shadow-lg">
                  <Icon name={item?.icon} size={20} className="text-white" />
                </div>
                {/* Connector line between dots (hidden for the last item) */}
                {index < timelineData.length - 1 && (
                  <div className="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-8 bg-gradient-to-b from-primary to-transparent"></div>
                )}
              </div>

              {/* Timeline Content */}
              <div className="flex-1 pb-8">
                <div className="bg-background border border-border rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="text-lg font-semibold text-foreground">{item?.title}</h4>
                    <span className="text-primary font-medium">{item?.year}</span>
                  </div>
                  
                  <p className="text-muted-foreground mb-4">{item?.description}</p>
                  
                  {/* Technologies */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {item?.technologies?.map((tech, techIndex) => (
                      <span
                        key={techIndex}
                        className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-md font-medium"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  {/* Key Achievements */}
                  {item?.achievements && (
                    <div>
                      <h5 className="text-sm font-semibold text-foreground mb-2">Key Achievements:</h5>
                      <ul className="space-y-1">
                        {item.achievements.map((achievement, achIndex) => (
                          <li key={achIndex} className="flex items-start space-x-2">
                            <Icon name="CheckCircle" size={14} className="text-success mt-0.5 flex-shrink-0" />
                            <span className="text-sm text-muted-foreground">{achievement}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Complexity Level */}
                  <div className="mt-4 pt-4 border-t border-border">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-foreground">Complexity Level:</span>
                      <div className="flex items-center space-x-1">
                        {[...Array(5)].map((_, i) => (
                          <div
                            key={i}
                            className={`w-2 h-2 rounded-full ${
                              i < item.complexityLevel ? 'bg-primary' : 'bg-muted'
                            }`}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechnicalTimeline;